import { ME } from "../types";

export const userReducer = (state = { isLoading: true, data: {} }, action) => {
  switch (action.type) {
    case ME:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
